import {SpecificDegreeOfKinshipTypeEnum} from "../pso-family-agreement.view-model.interface";
import {IServiceFactory} from "../../../../../../service-factory.interface";
import {IPsoFamilySpecificDegreeTypeViewModel} from "./pso-family-specific-degree-type.view-model.interface";

export class PsoFamilySpecificDegreeTypeModel implements IPsoFamilySpecificDegreeTypeViewModel {
    constructor(public readonly value: SpecificDegreeOfKinshipTypeEnum, private readonly services: IServiceFactory) {
    }

    get name(): string {
        switch (this.value) {
            case SpecificDegreeOfKinshipTypeEnum.Spouse:
                return this.services.language.translate('Spouse');
            case SpecificDegreeOfKinshipTypeEnum.Child:
                return this.services.language.translate('CHILD_RELATIVE');
            case SpecificDegreeOfKinshipTypeEnum.Parent:
                return this.services.language.translate('Parent');
            default:
                return 'Unknown';
        }
    }
}